module.exports = __webpack_public_path__ + "img/LC.2b311cc7.png";